/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryDuplicateEntryRequest
 */
export interface RevisdomAPIViewModelsEntryDuplicateEntryRequest {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryDuplicateEntryRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryDuplicateEntryRequest
     */
    entryType?: RevisdomAPIViewModelsEntryDuplicateEntryRequestEntryTypeEnum;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsEntryDuplicateEntryRequestEntryTypeEnum = {
    Project: 'Project',
    Folder: 'Folder',
    File: 'File',
    Version: 'Version'
} as const;
export type RevisdomAPIViewModelsEntryDuplicateEntryRequestEntryTypeEnum = typeof RevisdomAPIViewModelsEntryDuplicateEntryRequestEntryTypeEnum[keyof typeof RevisdomAPIViewModelsEntryDuplicateEntryRequestEntryTypeEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryDuplicateEntryRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryDuplicateEntryRequest(value: object): value is RevisdomAPIViewModelsEntryDuplicateEntryRequest {
    return true;
}

export function RevisdomAPIViewModelsEntryDuplicateEntryRequestFromJSON(json: any): RevisdomAPIViewModelsEntryDuplicateEntryRequest {
    return RevisdomAPIViewModelsEntryDuplicateEntryRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryDuplicateEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryDuplicateEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
    };
}

export function RevisdomAPIViewModelsEntryDuplicateEntryRequestToJSON(json: any): RevisdomAPIViewModelsEntryDuplicateEntryRequest {
    return RevisdomAPIViewModelsEntryDuplicateEntryRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryDuplicateEntryRequestToJSONTyped(value?: RevisdomAPIViewModelsEntryDuplicateEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entryType': value['entryType'],
    };
}

